import type { Result } from '../useAlertBanner/alertBannerNotificationsQuery';

type BuildUpgradeUrlOpts = {
  currentPlanName: string;
  upgradePlanName: string;
  interval: 'month' | 'year';
};
export const buildUpgradeUrl = (opts: BuildUpgradeUrlOpts) => {
  const currentPlanName = (opts.currentPlanName || '').toLowerCase();
  const upgradePlanName = (opts.upgradePlanName || '').toLowerCase();
  const url =
    currentPlanName && upgradePlanName
      ? `/app/billing/plans/upgrade/${currentPlanName}/${upgradePlanName}?interval=${
          opts.interval || 'month'
        }`
      : '/app/pricing';
  return encodeURI(url);
};

/**
 *
 * Evaluate offers for a specific campaign
 * https://coda.io/d/Revenue-Growth_d_s-Io-GBfk/Project-Sunset_su-G7#_luEdl
 *
 * Render only if no offer for this campaign has been already accepted or has expired
 */
export const getShouldRenderSunsetCopy = (
  campaignOffers: Result['data']['currentAccount']['campaignOffers'] = []
) => {
  // if one of the offers got accepted, user is filtered out of our target
  // expiry dates will be the same for all Sunset offers
  const hasSunsetOffer =
    campaignOffers.length &&
    campaignOffers.every(
      (offer) =>
        !offer.acceptedAt &&
        offer.expiry &&
        new Date(offer.expiry) >= new Date()
    );

  return hasSunsetOffer;
};
